import React from 'react'

const TrashIcon = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#000" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 6h20M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M9 10v8M15 10v8" />
        <path d="M20 6v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6" />
      </g>
    </svg>
  )
}

export default TrashIcon
